import axios from 'axios/index';

export default function addEditCustomer(customer, config) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };

  const url = config.postCustomers;
  return dispatch => dispatch({
    type: 'ADD_EDIT_CUSTOMER_SAVE',
    payload: axios({ method: 'post', url, headers, data: { customer } })
  });
}



// WEBPACK FOOTER //
// ./src/actions/addEditCustomer.js